/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

// Pipelines has chosen this as their default Connect add-on height
export const webPanelHeight = '50px';
export const webPanelWidth = '100%';

export const SourceWebPanel = styled.div({
  display: 'flex',
  position: 'relative',
  marginBottom: token('space.300'),
  minHeight: webPanelHeight,
  maxHeight: '280px',
  overflow: 'auto',
  iframe: {
    display: 'block',
  },
});

export const PullRequestWebPanel = styled.div({
  display: 'flex',
  position: 'relative',
  marginTop: token('space.100'),
  overflow: 'auto',
  minHeight: webPanelHeight,
  maxHeight: '600px',
  iframe: {
    display: 'block',
    overflow: 'auto',
  },
});

export const WebPanelHeader = styled.span({
  font: token('font.heading.xsmall'),
  marginTop: token('space.200'),
});

export const WebPanelSection = styled.section({
  marginTop: token('space.100'),
  marginBottom: token('space.100'),
});
